import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ngfModule } from 'angular-file';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '.././app-routing.module';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { OnboardingLayoutComponent } from './onboarding-layout/onboarding-layout.component';
import { SharedModule } from '../shared/shared.module';
import { ModalsModule } from '../modals/modals.module';
import { NavigationComponent } from '../core/components/navigation/navigation.component';
import { OfficeNavComponent } from '../core/components/office-nav/office-nav.component';
import { OfficeLayoutComponent } from './office-layout/office-layout.component';
import { SmNavComponent } from '../core/components/sm-nav/sm-nav.component';
import { SmLayoutComponent } from './sm-layout/sm-layout.component';
import { BellNotificationComponent } from '../core/components/bell-notification/bell-notification.component';

@NgModule({
  declarations: [
    OnboardingLayoutComponent,
    NavigationComponent,
    HomeLayoutComponent,
    OfficeNavComponent,
    OfficeLayoutComponent,
    SmNavComponent,
    SmLayoutComponent,
    BellNotificationComponent,
  ],
  imports: [CommonModule, SharedModule, ModalsModule, AppRoutingModule, ngfModule, FormsModule],
  exports: [HomeLayoutComponent, OnboardingLayoutComponent, OfficeLayoutComponent, SmLayoutComponent],
})
export class LayoutModule {}
